import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { useEffect, useState } from "react";
import axios from "../api/axios";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 5.75rem);
  padding: 3.3rem 0;
  display: flex;
  justify-content: center;
  background: #d5f0ee;
  // border: 1px solid black;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 62.5rem;
  height: 100%;
  display: flex;
  // align-items: center;
  justify-content: center;
  background: #d5f0ee;
`;

const Banner = styled.div`
  width: 24.75rem;
  height: 36.25rem;
  background-image: url(${({ url }) => url});
  // border: 1px solid black;
  background-position: center;
  // background-size: contain;
  background-size: 100% 37rem;
  background-repeat: no-repeat;
  border-radius: 1.25rem;
`;

const MenuContainer = styled.div`
  margin-left: 2.75rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 3.25rem;
  grid-row-gap: 2.63rem;
  height: 36.38rem;
`;

const Item = styled.div`
  width: 15.63rem;
  height: 16.88rem;
  border-radius: 1.25rem;
  box-shadow: 0px 5px 5px rgba(60, 122, 117, 0.12);
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme, disabled }) =>
    disabled ? theme.grayScaleColor.gray30 : theme.grayScaleColor.black};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: #00dbb1;
    color: white;
  }
  transition: 0.3s;
`;

const ItemSvg = styled.svg`
  margin-top: 4.75rem;
  // &:hover {
  //   path {
  //     fill: ${({ theme }) => theme.grayScaleColor.white};
  //   }
  // }
  // transition: all 0.3s;
`;

const ItemText = styled.span`
  font-size: 1.44rem;
  line-height: 1.75rem;
  margin-bottom: 2.69rem;
`;

const SlideContainer = styled.div`
  width: 24.75rem;
  height: 36.25rem;
  //   border: 1px solid black;
  position: relative;
`;

const IndicatorContainer = styled.div`
  border: 1px solid black;
`;
const IndicatorCircle = styled.div`
  width: 0.63rem;
  height: 0.63rem;
  border-radius: 50%;
  margin: 0 0.28rem;
  background: ${({ theme }) => theme.grayScaleColor.white};
  cursor: pointer;
  //   &:nth-child(${({ highlight }) => highlight}) {
  //     background: ${({ theme }) => theme.primary.normal};
  //   }
  &.active {
    width: 1.44rem;
    border-radius: 1.25rem;
    background: ${({ theme }) => theme.primary.normal};
  }
  transition: all 0.3s;
`;

const Indicators = (index) => (
  <IndicatorCircle highlight={index + 1}></IndicatorCircle>
);

function Home() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [hovers, setHovers] = useState([0, 0, 0, 0]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("/home/banner");
      setImages(response.data.banners);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  if (isLoading) return null;

  return (
    <Container>
      <Wrapper>
        <SlideContainer>
          <Slide
            indicators={Indicators}
            arrows={false}
            transitionDuration={400}
          >
            {images.map((slideImage, index) => {
              return (
                <div className="each-slide" key={index}>
                  <div
                    onClick={() =>
                      navigate("/announcement", {
                        state: { id: slideImage.postId },
                      })
                    }
                    style={{
                      width: "24.75rem",
                      height: "36.25rem",
                      // backgroundColor: "red",
                      backgroundImage: `url(${slideImage.url})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      cursor: "pointer",
                    }}
                  ></div>
                </div>
              );
            })}
          </Slide>
        </SlideContainer>
        {/* <Banner
          url={`${process.env.PUBLIC_URL}/assets/home-banner.png`}
        ></Banner> */}
        <MenuContainer>
          <Item
            onClick={() => navigate("/dashboard/mypage")}
            onMouseEnter={() => setHovers([1, 0, 0, 0])}
            onMouseLeave={() => setHovers([0, 0, 0, 0])}
          >
            <ItemSvg
              width="83"
              height="69"
              viewBox="0 0 83 69"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ transition: "0.3s" }}
                d="M77.9697 0H67.9091C65.1424 0 62.8788 2.3 62.8788 5.11111C62.8788 7.92222 60.6152 10.2222 57.8485 10.2222C55.0818 10.2222 52.8182 7.92222 52.8182 5.11111C52.8182 2.3 50.5545 0 47.7879 0H35.2121C32.4455 0 30.1818 2.3 30.1818 5.11111C30.1818 7.92222 27.9182 10.2222 25.1515 10.2222C22.3848 10.2222 20.1212 7.92222 20.1212 5.11111C20.1212 2.3 17.8576 0 15.0909 0H5.0303C2.26364 0 0 2.3 0 5.11111V63.8889C0 66.7 2.26364 69 5.0303 69H77.9697C80.7364 69 83 66.7 83 63.8889V5.11111C83 2.3 80.7364 0 77.9697 0ZM21.7309 23.23C25.7552 23.23 28.9997 26.5522 28.9997 30.6156C28.9997 34.6789 25.73 38.0011 21.7309 38.0011C17.7318 38.0011 14.4621 34.6789 14.4621 30.6156C14.4621 26.5522 17.7318 23.23 21.7309 23.23ZM33.9545 52.0567C33.9545 53.0789 33.2 53.8967 32.2694 53.8967H11.1673C10.2367 53.8967 9.48212 53.0789 9.48212 52.0567V50.3189C9.48212 46.9967 11.947 44.2878 14.9903 44.2878H28.4464C31.4897 44.2878 33.9545 46.9967 33.9545 50.3189V52.0567ZM67.9091 50.4722H45.2727C43.5373 50.4722 42.1288 49.0411 42.1288 47.2778C42.1288 45.5144 43.5373 44.0833 45.2727 44.0833H67.9091C69.6445 44.0833 71.053 45.5144 71.053 47.2778C71.053 49.0411 69.6445 50.4722 67.9091 50.4722ZM67.9091 37.6944H45.2727C43.5373 37.6944 42.1288 36.2633 42.1288 34.5C42.1288 32.7367 43.5373 31.3056 45.2727 31.3056H67.9091C69.6445 31.3056 71.053 32.7367 71.053 34.5C71.053 36.2633 69.6445 37.6944 67.9091 37.6944Z"
                fill={hovers[0] ? "#FFFFFF" : "#00DBB1"}
              />
            </ItemSvg>
            <ItemText>나의 멤버십 정보</ItemText>
          </Item>
          <Item
            onClick={() => navigate("/guide")}
            onMouseEnter={() => setHovers([0, 1, 0, 0])}
            onMouseLeave={() => setHovers([0, 0, 0, 0])}
          >
            <ItemSvg
              width="83"
              height="81"
              viewBox="0 0 83 81"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ transition: "0.3s" }}
                d="M66.3564 42.0797C66.3564 40.5907 65.148 39.3823 63.659 39.3823H37.7638C36.2748 39.3823 35.0664 40.5907 35.0664 42.0797C35.0664 43.5686 36.2748 44.7771 37.7638 44.7771H63.659C65.148 44.7771 66.3564 43.5686 66.3564 42.0797ZM10.7897 62.58C9.6028 62.58 8.63173 61.609 8.63173 60.4221V23.7373C8.63173 22.5504 9.6028 21.5793 10.7897 21.5793H66.8959C68.0828 21.5793 69.0538 22.5504 69.0538 23.7373V44.065L77.6856 35.4332V8.63173C77.6856 3.8627 73.8229 0 69.0538 0H8.63173C3.8627 0 0 3.8627 0 8.63173V62.58C0 67.3491 3.8627 71.2118 8.63173 71.2118H43.8492C44.0218 69.8091 44.6476 68.4928 45.6403 67.4785C46.4171 66.7017 48.5966 64.5222 48.5966 64.5222L50.5388 62.58H10.7897ZM25.8952 7.55276H34.5269C36.318 7.55276 37.7638 8.99858 37.7638 10.7897C37.7638 12.5807 36.318 14.0266 34.5269 14.0266H25.8952C24.1041 14.0266 22.6583 12.5807 22.6583 10.7897C22.6583 8.99858 24.1041 7.55276 25.8952 7.55276ZM12.9476 6.4738C15.3213 6.4738 17.2635 8.41593 17.2635 10.7897C17.2635 13.1634 15.3213 15.1055 12.9476 15.1055C10.5739 15.1055 8.63173 13.1634 8.63173 10.7897C8.63173 8.41593 10.5739 6.4738 12.9476 6.4738ZM82.1525 52.5241L75.9592 46.3308C75.5276 45.8992 74.8587 45.8992 74.4271 46.3308L57.0773 63.6806C56.6457 64.1122 56.6457 64.7811 57.0773 65.2127L63.2706 71.406C63.7022 71.8376 64.3711 71.8376 64.8027 71.406L82.1525 54.0562C82.5841 53.6246 82.5841 52.9557 82.1525 52.5241ZM53.193 69.097C52.783 68.687 52.0925 68.6654 51.6825 69.097C50.9704 69.7875 49.9777 70.8018 49.4814 71.2765C49.3087 71.4491 49.2009 71.6865 49.1793 71.9455L48.6398 78.9372C48.5966 79.6061 49.1577 80.1672 49.8482 80.1024L56.5594 79.3256C56.7968 79.304 57.0341 79.1961 57.2068 79.0235L59.4079 76.8224C59.8395 76.3908 59.8395 75.7218 59.4079 75.2902L53.2146 69.097H53.193ZM16.1845 50.1719C14.6955 50.1719 13.4871 51.3804 13.4871 52.8693C13.4871 54.3583 14.6955 55.5667 16.1845 55.5667H55.0273C56.5162 55.5667 57.7247 54.3583 57.7247 52.8693C57.7247 51.3804 56.5162 50.1719 55.0273 50.1719H16.1845ZM63.659 28.5926H37.7638C36.2748 28.5926 35.0664 29.801 35.0664 31.29C35.0664 32.779 36.2748 33.9874 37.7638 33.9874H63.659C65.148 33.9874 66.3564 32.779 66.3564 31.29C66.3564 29.801 65.148 28.5926 63.659 28.5926Z"
                fill={hovers[1] ? "#FFFFFF" : "#00DBB1"}
              />
            </ItemSvg>
            <ItemText disabled={true}>맘핏 센터 이용안내</ItemText>
          </Item>
          <Item
            onClick={() => navigate("/recommend")}
            onMouseEnter={() => setHovers([0, 0, 1, 0])}
            onMouseLeave={() => setHovers([0, 0, 0, 0])}
          >
            <ItemSvg
              width="56"
              height="87"
              viewBox="0 0 56 87"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ transition: "0.3s" }}
                d="M38.0389 78.9131H18.0153C15.8127 78.9131 14.0105 80.7152 14.0105 82.9178C14.0105 85.1204 15.8127 86.9225 18.0153 86.9225H38.0389C40.2415 86.9225 42.0436 85.1204 42.0436 82.9178C42.0436 80.7152 40.2415 78.9131 38.0389 78.9131Z"
                fill={hovers[2] ? "#FFFFFF" : "#00DBB1"}
              />
              <path
                style={{ transition: "0.3s" }}
                d="M24.9434 0.635377C10.0858 2.21724 -1.12738 16.5141 0.174153 31.4117C1.87616 50.9147 19.8173 65.4719 25.9646 69.9171C27.186 70.7981 28.8079 70.7781 30.0093 69.837C36.3969 64.8511 56 47.9512 56 28.4482C55.98 11.9888 41.7832 -1.14672 24.9434 0.635377ZM28.007 39.5413C21.8798 39.5413 16.9139 34.5754 16.9139 28.4482C16.9139 22.321 21.8798 17.3551 28.007 17.3551C34.1342 17.3551 39.1001 22.321 39.1001 28.4482C39.1001 34.5754 34.1342 39.5413 28.007 39.5413Z"
                fill={hovers[2] ? "#FFFFFF" : "#00DBB1"}
              />
            </ItemSvg>
            <ItemText disabled={false}>추천 코스</ItemText>
          </Item>
          <Item
            onClick={() => navigate("/faq")}
            onMouseEnter={() => setHovers([0, 0, 0, 1])}
            onMouseLeave={() => setHovers([0, 0, 0, 0])}
          >
            <ItemSvg
              width="82"
              height="73"
              viewBox="0 0 82 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ transition: "0.3s" }}
                d="M80.8569 69.5646L77.1568 58.4645C76.9513 57.8273 77.0129 57.149 77.3213 56.5529C80.0963 51.1467 81.2474 44.7744 80.0552 38.0527C78.2052 27.7542 70.6612 19.1825 60.8767 15.8936C63.405 21.9986 64.1656 28.782 62.9117 35.5038C60.3422 49.1733 49.4065 60.0268 35.6753 62.4729C33.9075 62.8018 32.0986 62.9457 30.3102 62.9868C34.4831 67.4885 40.0537 70.6747 46.2615 71.8052C52.9421 72.9975 59.2939 71.8874 64.6795 69.1535C65.2756 68.8452 65.9539 68.7835 66.5706 68.9891L77.7118 72.7097C79.6646 73.3675 81.5146 71.4969 80.8774 69.5441L80.8569 69.5646Z"
                fill={hovers[3] ? "#FFFFFF" : "#00DBB1"}
              />
              <path
                style={{ transition: "0.3s" }}
                d="M23.8762 0.518047C12.3033 2.6764 3.03268 12.0704 0.956546 23.6638C-0.256244 30.3856 0.894879 36.7579 3.69046 42.164C3.9988 42.7601 4.06047 43.4385 3.85491 44.0757L0.134316 55.1758C-0.523469 57.1286 1.34711 58.9786 3.2999 58.3414L14.4411 54.6208C15.0784 54.4153 15.7361 54.4769 16.3323 54.7853C21.7179 57.5192 28.0696 58.6292 34.7502 57.437C46.3026 55.3608 55.676 46.1107 57.8549 34.5789C61.6577 14.2287 44.2059 -3.26421 23.8762 0.518047ZM29.2002 47.7346C27.1857 47.7346 25.5412 46.0902 25.5412 44.0757C25.5412 42.0612 27.1857 40.4168 29.2002 40.4168C31.2146 40.4168 32.8591 42.0612 32.8591 44.0757C32.8591 46.0902 31.2146 47.7346 29.2002 47.7346ZM32.7358 31.7217L32.7974 33.1606C32.7974 35.1545 31.1941 36.7579 29.2002 36.7579C27.2063 36.7579 25.6029 35.1545 25.6029 33.1606V31.8656C25.6029 28.7411 27.494 25.9661 30.3307 24.9588C31.6463 24.4861 32.5508 23.2322 32.5508 21.8138C32.5508 20.971 32.1807 20.1077 31.5435 19.4705C30.8857 18.8127 30.1046 18.4838 29.2002 18.4632C27.3707 18.4632 25.8701 19.9844 25.8701 21.8138C25.8701 23.8077 24.2668 25.4111 22.2729 25.4111C20.279 25.4111 18.6756 23.8077 18.6756 21.8138C18.6756 16.0376 23.3829 11.3098 29.1591 11.2687C31.9546 11.1659 34.6474 12.3993 36.6413 14.3932C38.6353 16.3871 39.7864 19.121 39.7658 21.8755C39.7453 26.295 36.9291 30.2622 32.7769 31.7423L32.7358 31.7217Z"
                fill={hovers[3] ? "#FFFFFF" : "#00DBB1"}
              />
            </ItemSvg>

            <ItemText>문의사항</ItemText>
          </Item>
        </MenuContainer>
      </Wrapper>
    </Container>
  );
}

export default Home;
